<template>
  <div class="forbidden-widget" data-t="forbidden-widget">
    {{ t('webTelegramForbidden.widget') }}
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()
</script>

<style scoped>
.forbidden-widget {
  overflow: hidden;

  padding: var(--spacing-125) var(--spacing-150);

  font: var(--mobile-text-semibold);
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;

  background-color: var(--background-error);
}
</style>
